"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var Icon_1 = __importDefault(require("../Icon"));
var styled_components_1 = __importStar(require("../Themes/styled-components"));
var Breadcrumbs_1 = __importDefault(require("./Breadcrumbs"));
var User_1 = __importDefault(require("./User"));
var utilities_1 = require("../Themes/utilities");
var AVATAR_SIZE = 32;
exports.TITLE_PANEL_HEIGHT = 54;
exports.TITLE_PANEL_HEIGHT_M = 64;
var Wrapper = styled_components_1.default('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  height: ", ";\n  font-family: ", ";\n  box-sizing: border-box;\n  background-color: ", ";\n  padding: 0 ", ";\n  border-bottom: solid 1px ", ";\n  margin: 0;\n  ", " {\n    height: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  height: ", ";\n  font-family: ", ";\n  box-sizing: border-box;\n  background-color: ", ";\n  padding: 0 ", ";\n  border-bottom: solid 1px ", ";\n  margin: 0;\n  ", " {\n    height: ", ";\n  }\n"])), polished_1.rem(exports.TITLE_PANEL_HEIGHT), function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.backgroundColor;
}, polished_1.rem(12), function (_a) {
    var theme = _a.theme;
    return theme.separatorColor;
}, utilities_1.mb('m'), polished_1.rem(exports.TITLE_PANEL_HEIGHT_M));
var RightWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  align-self: normal;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  align-self: normal;\n"])));
var LeftWrapper = styled_components_1.default('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
var Item = styled_components_1.default('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: ", ";\n  text-align: left;\n  color: ", ";\n  margin-left: ", ";\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"], ["\n  font-size: ", ";\n  text-align: left;\n  color: ", ";\n  margin-left: ", ";\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"])), polished_1.rem(14), function (_a) {
    var theme = _a.theme;
    return theme.textColor;
}, function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.grid.gutterWidth);
});
var Text = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-left: ", ";\n  display: flex;\n  flex-direction: column;\n"], ["\n  margin-left: ", ";\n  display: flex;\n  flex-direction: column;\n"])), polished_1.rem(5));
var Title = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-weight: bold;\n  font-size: ", ";\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"], ["\n  font-weight: bold;\n  font-size: ", ";\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"])), polished_1.rem(18));
var TitleNameWrapper = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var ArrowWrapper = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 ", ";\n  margin-right: ", ";\n  height: ", ";\n  cursor: pointer;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 ", ";\n  margin-right: ", ";\n  height: ", ";\n  cursor: pointer;\n"])), polished_1.rem(3), polished_1.rem(12), polished_1.rem(44));
var Logo = styled_components_1.default.img(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: ", ";\n  max-height: 100%;\n  min-width: ", ";\n  margin-right: ", ";\n"], ["\n  width: ", ";\n  max-height: 100%;\n  min-width: ", ";\n  margin-right: ", ";\n"])), polished_1.rem(AVATAR_SIZE), polished_1.rem(AVATAR_SIZE), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.grid.gutterWidth);
});
var FlexIcon = styled_components_1.default(Icon_1.default)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var StatusBarAction = styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  align-self: stretch;\n  padding: 0 ", ";\n  margin-left: 1px;\n  :hover {\n    background-color: ", ";\n  }\n"], ["\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  align-self: stretch;\n  padding: 0 ", ";\n  margin-left: 1px;\n  :hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.grid.gutterWidth);
}, function (_a) {
    var theme = _a.theme;
    return theme.separatorColor;
});
var StatusBarActionLabel = styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  margin-left: ", ";\n"], ["\n  margin-left: ",
    ";\n"])), function (_a) {
    var theme = _a.theme, withIcon = _a.withIcon;
    return withIcon ? polished_1.rem(theme.grid.gutterWidth) : 0;
});
var TitlePanel = /** @class */ (function (_super) {
    __extends(TitlePanel, _super);
    function TitlePanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleArrowClick = function () {
            if (!_this.props.menuButton) {
                return;
            }
            if (_this.props.menuButton.opened) {
                _this.props.menuButton.onClose();
            }
            else {
                _this.props.menuButton.onOpen();
            }
        };
        _this.renderTitle = function () {
            var _a = _this.props.crumbs, crumbs = _a === void 0 ? [] : _a;
            return (React.createElement(React.Fragment, null,
                _this.props.menuButton && (React.createElement(ArrowWrapper, { onClick: _this.handleArrowClick, "data-testid": "Ui_Global_IconArrow_Menu" },
                    React.createElement(Icon_1.default, { size: "l", name: "burger", color: _this.props.menuButton.opened
                            ? _this.props.theme.color.primary
                            : _this.props.theme.color.fadedText }))),
                _this.props.logo && React.createElement(Logo, { alt: "logo", src: _this.props.logo }),
                React.createElement(TitleNameWrapper, null,
                    React.createElement(Title, null, _this.props.title),
                    React.createElement(Breadcrumbs_1.default, { crumbs: crumbs }))));
        };
        return _this;
    }
    TitlePanel.prototype.render = function () {
        var _a = this.props, name = _a.name, subname = _a.subname, avatarSrc = _a.avatarSrc, messages = _a.messages, onClickUser = _a.onClickUser, experimentalStatusBarActions = _a.experimentalStatusBarActions;
        return (React.createElement(Wrapper, null,
            React.createElement(LeftWrapper, null, this.renderTitle()),
            React.createElement(RightWrapper, null,
                experimentalStatusBarActions &&
                    experimentalStatusBarActions.map(function (action) {
                        return (React.createElement(StatusBarAction, { onClick: action.onClick },
                            action.icon,
                            action.label && (React.createElement(StatusBarActionLabel, { withIcon: !!action.icon }, action.label))));
                    }),
                (name || subname || avatarSrc) && (React.createElement(User_1.default, { name: name, subname: subname, notificationCount: messages, avatarSrc: avatarSrc, avatarSize: AVATAR_SIZE, onClick: onClickUser })),
                this.props.onLogout && (React.createElement(Item, { onClick: this.props.onLogout },
                    React.createElement(FlexIcon, { size: "l", name: "power-off" }),
                    React.createElement(Text, null, "Odhl\u00E1si\u0165 sa"))),
                this.props.onClose && (React.createElement(Item, { onClick: this.props.onClose },
                    React.createElement(FlexIcon, { size: "l", name: "close" }),
                    React.createElement(Text, null, "Ukon\u010Di\u0165"))))));
    };
    TitlePanel.defaultProps = {
        crumbs: [],
    };
    return TitlePanel;
}(React.PureComponent));
exports.default = styled_components_1.withTheme(TitlePanel);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;
